import React from 'react';
import { GetCurrencySymbol } from '../../../../../utils/Currency';
import { ImageUploadingIcon } from '../../../../../utils/SVGIcon';
import cn from '../../../../../utils/cn';

function CompPackages({ el, handlePackageSelect, checkedItems, handleCustomInput, option }) {
    const isFree = el?.amount === -102;
    // const classA =
    //     'text-primary-700 cursor-default select-none pointer-event-none focus:outline-none';

    const isChecked = checkedItems.some((d) => d.AppServicePackageId === el.packageId);

    // isFree ? true : checkedItems.includes(el.packageId)
    return (
        <label
            htmlFor={el?.pricingId}
            key={el?.pricingId}
            className="size-full flex items-center justify-start gap-2 px-3"
        >
            <input
                type="checkbox"
                id={el?.pricingId}
                onChange={(e) => handlePackageSelect(e, option.id, el.packageId, el.amount)}
                // disabled={isFree}
                checked={isChecked}
            />

            <div className="flex justify-between items-center w-full text-base font-normal">
                <span>{el?.packageName}</span>

                {el?.amount === -101 ? (
                    <span>
                        {GetCurrencySymbol(el?.currency)}{' '}
                        <input
                            type="text"
                            onChange={(e) => handleCustomInput(e, el)}
                            ref={(input) => {
                                if (input) {
                                    if (!checkedItems.includes(el.packageId)) {
                                        // eslint-disable-next-line no-param-reassign
                                        input.value = '';
                                    }
                                }
                            }}
                            placeholder="Enter Amount"
                            className="w-30 h-8 p-1 rounded-5 border border-gray-300 focus:outline-none disabled:bg-primary-100"
                            disabled={!checkedItems.includes(el.packageId)}
                        />
                    </span>
                ) : (
                    <span>
                        {!isFree ? GetCurrencySymbol(el?.currency) : null}
                        {isFree ? 'Free' : el?.amount || 0}
                    </span>
                )}
            </div>
        </label>
    );
}

function CompServiceList({ option, checkedItems, handlePackageSelect, handleCustomInput }) {
    return (
        <li className="w-full flex flex-col p-3 py-1">
            <span className="text-sm font-medium line-clamp-1">{option?.serviceTitle}</span>
            <div className="ml-2 flex flex-col gap-2">
                {option?.packages?.map((el) => (
                    <CompPackages
                        key={el?.pricingId}
                        el={el}
                        handlePackageSelect={handlePackageSelect}
                        checkedItems={checkedItems}
                        handleCustomInput={handleCustomInput}
                        option={option}
                    />
                ))}
            </div>
        </li>
    );
}

function Items({ appServiceList, handlePackageSelect, handleCustomInput, checkedItems }) {
    // if (appServiceList?.length === 0) {
    //     return (
    //         <div className="flex justify-center items-center py-4 bg-secondary-100 rounded-10">
    //             <span className="text-gray-500">
    //                 No Package found for this service or user current currency!
    //             </span>
    //         </div>
    //     );
    // }

    return (
        <ul className="w-full divide-y">
            {appServiceList?.map((option) => (
                <CompServiceList
                    option={option}
                    key={option.id}
                    handlePackageSelect={handlePackageSelect}
                    handleCustomInput={handleCustomInput}
                    checkedItems={checkedItems}
                />
            ))}
        </ul>
    );
}

const addItem = (dateAr, Amount, AppServiceId, AppServicePackageId) => {
    const exItem = dateAr.find((item) => item.AppServicePackageId === AppServicePackageId);

    if (!exItem) {
        dateAr.push({ Amount, AppServiceId, AppServicePackageId });
    }
};

const removeItem = (dateAr, AppServicePackageId) => {
    const index = dateAr.findIndex((item) => item.AppServicePackageId === AppServicePackageId);

    if (index !== -1) {
        dateAr.splice(index, 1);
    }
};

function AppServiceList({ appServicesList, isLoading, formData, setFormData }) {
    const onPackageSelectChange = (e, AppServiceId, AppServicePackageId, Amount) => {
        const { checked } = e.target;

        setFormData((prev) => {
            const sPackageData = [...prev.ServicePackageData]; // [{}]

            if (checked) {
                // Checked
                addItem(sPackageData, Amount, AppServiceId, AppServicePackageId);
            } else {
                // Unchecked
                removeItem(sPackageData, AppServicePackageId);
            }

            return { ...prev, ServicePackageData: sPackageData };
        });
    };

    // handle custom input
    const handleCustomInput = (e, packageItem) => {
        const { value } = e.target;
        const index = formData.findIndex((el) => el.AppServicePackageId === packageItem.packageId);
        if (index !== -1) {
            setFormData((prev) => {
                // eslint-disable-next-line no-param-reassign
                prev[index].Amount = Number(value) || 0;
                return [...prev];
            });
        } else {
            setFormData((prev) => [
                ...prev,
                {
                    AppServiceId: packageItem.AppServiceId,
                    AppServicePackageId: packageItem.packageId,
                    Amount: Number(value) || 0
                }
            ]);
        }
    };

    // useEffect(() => {
    //     // Map all packages
    //     for (let i = 0; i < appServicesList.length; i += 1) {
    //         const { packages } = appServicesList[i];
    //         for (let j = 0; j < packages.length; j += 1) {
    //             const AppServiceId = appServicesList[i].id;
    //             const AppServicePackageId = packages[j].packageId;
    //             const Amount = packages[j].amount;

    //             if (Amount === -102) {
    //                 setFormData((prev) => {
    //                     const sPackageData = [...prev.ServicePackageData]; // [{}]

    //                     addItem(sPackageData, Amount, AppServiceId, AppServicePackageId);
    //                     return { ...prev, ServicePackageData: sPackageData };
    //                 });
    //             }
    //         }
    //     }
    // }, [appServicesList, setFormData]);

    return (
        <div className={cn('flex flex-col gap-2 relative')}>
            <h2 className="font-medium">Addon Services:</h2>
            <div
                className={cn(
                    'h-48 bg-secondary-100 p-2 rounded-10 ',
                    isLoading ? 'opacity-50' : ''
                )}
            >
                {/* Showing loading spinner */}
                {isLoading && (
                    <div className="absolute size-40 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <ImageUploadingIcon />
                    </div>
                )}
                {/* {!isLoading && appServicesList && appServicesList?.length === 0 ? (
                    <div className="flex justify-center items-center py-4 bg-secondary-100 rounded-10">
                        <span className="text-gray-500">
                            No service found or user current currency!
                        </span>
                    </div>
                ) : ( */}
                <div className="h-full overflow-x-auto rounded-10 custom-scrollbar">
                    {!isLoading && appServicesList && appServicesList?.length === 0 ? (
                        <div className="h-full flex justify-center items-center ">
                            <span className="text-gray-500">
                                No service found or user current currency!
                            </span>
                        </div>
                    ) : (
                        <Items
                            isLoading={isLoading}
                            appServiceList={appServicesList}
                            handlePackageSelect={onPackageSelectChange}
                            handleCustomInput={handleCustomInput}
                            checkedItems={formData.ServicePackageData}
                        />
                    )}
                </div>
                {/* )} */}
            </div>
        </div>
    );
}

export default AppServiceList;
